import { useTranslation } from 'react-i18next';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { formatFullDateAndTime } from 'src/utils/dateFormatter';

import { CheckinBlockerSessionDetails } from './_types';

type SessionDetailSectionProps = {
  label: string;
  value: string;
};

function SessionDetailSection({ label, value }: SessionDetailSectionProps) {
  return (
    <Stack spacing={0.5} sx={{ width: '100%' }}>
      <Typography variant="bodyLargeStrong">{label}</Typography>
      <Typography variant="body2">{value}</Typography>
    </Stack>
  );
}

type BookingSessionDetailsProps = {
  sessionDetails: CheckinBlockerSessionDetails;
};

export function BookingSessionDetails({
  sessionDetails,
}: BookingSessionDetailsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'checkinBlocker.sessionDetails',
  });

  const whenValue = (() => {
    const formattedStart = formatFullDateAndTime(
      sessionDetails.startTime * 1000,
      {
        weekday: 'long',
        year: undefined,
      }
    );

    if (sessionDetails.duration == null) {
      return formattedStart;
    }

    return t('whenWithDuration', {
      when: formattedStart,
      duration: sessionDetails.duration,
    });
  })();

  return (
    <Stack spacing={2.5} sx={{ width: '100%' }}>
      {sessionDetails.trainerNames ? (
        <SessionDetailSection
          label={t('staff')}
          value={sessionDetails.trainerNames}
        />
      ) : null}
      {sessionDetails.locationName ? (
        <SessionDetailSection
          label={t('location')}
          value={sessionDetails.locationName}
        />
      ) : null}
      <SessionDetailSection label={t('when')} value={whenValue} />
      {sessionDetails.attendeeCount != null ? (
        <SessionDetailSection
          label={t('whosGoing')}
          value={t('attendeeCount', { count: sessionDetails.attendeeCount })}
        />
      ) : null}
    </Stack>
  );
}
